export default __webpack_public_path__ + "static/media/060-bank-account.12adde0d.svg";